<template>

    <el-menu style="border: none !important;" class="el-menu-demo" mode="horizontal" :ellipsis="false"
        background-color="#1f2937" text-color="#e5e7eb" @select="handleSelect">
        <div class="nav-el-radio"
            style="height: fit-content;font-weight: 600;margin-top: 0.875rem;margin-left: 0.75rem;color:#e5e7eb;cursor:pointer;transition:all 0.15s ease;"
            @click="toggleCollapse()">
            <span v-if="isCollapse1 == 1 && isWindow" class="iconfont icon-zhedie-shouqi"></span>
            <span v-else-if="isCollapse1 == 0 && !isWindow" class="iconfont icon-zhedie-shouqi"></span>
            <span v-else-if="isCollapse1 == 0 && isWindow" class="iconfont icon-zhedie-zhankai"></span>
            <span v-else class="iconfont icon-zhedie-zhankai"></span>
        </div>
        <el-sub-menu style="right: 0;position: absolute;" index="1">
            <template #title>{{ user_conf.user_email ? (user_conf.username ? user_conf.username : "未设置") : "未登录" }}</template>
            <el-menu-item index="1-1" class="ml-2" @click="navigateTo('/')"><span class="iconfont icon-gerenziliao2"
                    style="font-size: 1rem !important;margin-right: 6px;"></span>个人资料</el-menu-item>
            <el-menu-item index="1-2" class="ml-2" @click="navigateTo('/userLog')"><span class="iconfont icon-rizhi"
                    style="font-size: 1rem !important;margin-right: 6px;"></span>用户日志</el-menu-item>
            <el-menu-item index="1-3" class="ml-2" @click="navigateTo('/dockKey')"><span class="iconfont icon-jiekou"
                    style="font-size: 1rem !important;margin-right: 6px;"></span>对接密钥</el-menu-item>
            <el-menu-item index="1-4" class="ml-2" @click="outLogin()"> <span class="iconfont icon-tuichu1"
                    style="margin-right: 6px;margin-left: 3px;"></span>退出</el-menu-item>
        </el-sub-menu>
    </el-menu>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';
import { mapState, useStore } from 'vuex';
var isWindow = window.innerWidth > 768;
const activeIndex = ref('1')
const user_conf = ref(JSON.parse(localStorage.getItem("user_conf") || "{}"));
const handleSelect = (key: string, keyPath: string[]) => {
    console.log(key, keyPath)
}
const store = useStore();


var isCollapse1 = ref(store.getters.isCollapse);
if (localStorage.getItem("isCollapse") == "-1") {
    store.commit('setIsCollapse', -1);
    isCollapse1.value = -1;
} else if (localStorage.getItem("isCollapse") == "1") {
    store.commit('setIsCollapse', 1);
    isCollapse1.value = 1;
} else {
    store.commit('setIsCollapse', 0);
    isCollapse1.value = 0;
}
// 处理点击事件以切换折叠状态
const toggleCollapse = () => {
    if (isCollapse1.value == 1) {
        isCollapse1.value = 0;
    } else if (isCollapse1.value == 0) {
        if (isWindow) {
            isCollapse1.value = 1;
        } else {
            isCollapse1.value = -1;
        }
    } else {
        isCollapse1.value = 0;
    }
    store.commit('setIsCollapse', isCollapse1.value);
    localStorage.setItem('isCollapse', isCollapse1.value);
};
const router = useRouter();
const navigateTo = (path: string) => {
    store.dispatch('setIsCollapse', isCollapse1.value);
    router.push(path);

}
const outLogin = () => {
    ElMessageBox.confirm(
        '您确定要退出登录吗？',
        'Warning',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("user_conf");
            ElMessage.success("退出登录成功")
            setTimeout(() => {
                location.reload();
            }, 1000);
        })
        .catch(() => {
            console.log();
        })
}

</script>

<style>
.el-menu--horizontal>.el-menu-item:nth-child(1) {
    margin-right: auto;
}

.el-menu-demo {
    .el-sub-menu__title {
        font-size: 0.875rem;
        font-weight: 500;
        transition: all 0.15s ease;

        &:hover {
            background-color: rgba(99, 102, 241, 0.15) !important;
            color: #6366f1 !important;
        }
    }

    .el-menu-item {
        font-size: 0.875rem;
        font-weight: 500;
        transition: all 0.15s ease;

        &:hover {
            background-color: rgba(99, 102, 241, 0.08) !important;
            color: #6366f1 !important;
        }
    }

    .el-popper {
        border-radius: 6px;
        box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.04),
            0 4px 12px rgba(0, 0, 0, 0.04);
        border: 1px solid #e5e7eb;

        .el-menu--popup {
            padding: 0.25rem;
            background: #fff;

            .el-menu-item {
                height: 2.25rem;
                line-height: 2.25rem;
                border-radius: 4px;
                margin: 0.125rem 0;
                color: #374151;

                &:hover {
                    background-color: #f9fafb !important;
                    color: #6366f1 !important;
                }
            }
        }
    }
}

.nav-el-radio:hover {
    color: #6366f1 !important;
}
</style>